module.exports = __webpack_public_path__ + "static/media/logo_pn_fr.fd8112de.svg";